import * as React from 'react';
import SearchView from 'containers/search';
import { PwrDistroAnswerFieldsets } from 'containers/search/SearchForm';

export function AnswerSearch(props) {
  return (
    <SearchView
      label="Answers"
      primaryFieldsets={PwrDistroAnswerFieldsets.primaryFieldsets}
      extraFieldsets={PwrDistroAnswerFieldsets.extraFieldsets}
      {...props}
    />
  );
}



// WEBPACK FOOTER //
// ./src/containers/search/PwrDistribution/AnswerSearch.js